import { HorizontalDivider } from '@bos/ui';

export const AppHorizontalDivider = () => <HorizontalDivider />;
